<template>
  <div class="page-maindiv">
    <!-- Main -->
    <div class="area-main">
      <!-- Area titolo -->
      <div class="area-top">
        <div class="area-top-title">
          {{ $t('orchestra') }}
        </div>
      </div>
      <div class="area-description" v-if="!loading">
        <div v-html="pageDescription" v-if="!loading"></div>
        <b-button id="button-more" pill variant="info" class="p-1 mb-4 button-color" v-if="pageDescriptionMore != ''" v-b-toggle.collapse-more >{{ $t(buttonMoreTranslationKey) }}</b-button>
        <b-collapse id="collapse-more" class="mt-2" @shown="buttonMoreTranslationKey = 'readless'" @hidden="buttonMoreTranslationKey = 'readmore'">
          <p class="card-text text-left" v-html="pageDescriptionMore"></p>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Orchestra',
  data: function() {
    return {
      buttonMoreTranslationKey: "readmore",
      pageDescriptionRecord: "",
      loading: true,
    };
  },
  created() {
    this.fetchOrchestra()
  },
  computed: {
    pageDescription() {
      let desc = "";
      if (this.pageDescriptionRecord != null)
        for (let trad in this.pageDescriptionRecord["traduzioni"]) {
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith("it"))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith(this.$i18n.locale))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
        }
      return desc;
    },
    pageDescriptionMore() {
      let desc = "";
      if (this.pageDescriptionRecord != null)
        for (let trad in this.pageDescriptionRecord["traduzioni"]) {
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith("it"))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto2;
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith(this.$i18n.locale))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto2;
        }
      return desc;
    },
  },
  methods: {
    async fetchOrchestra() {
      const pageDescriptionData = await this.$client.getItems("pagine", {
        fields: ["*", "traduzioni.*"],
        filter: {
          nome: {
            eq: 'orchestra'
          }
        }
      });
      if (pageDescriptionData.data !== null && pageDescriptionData.data.length > 0)
        this.pageDescriptionRecord = pageDescriptionData.data[0];

      this.loading = false;
    },
  }
}
</script>

<style>
</style>